import React from "react";
import styled from "@emotion/styled/macro";
import { Modal, Typography, tokens } from "@sunrun/experience-ui-components";
import { getProspectUnavailablePresentation } from "utils/contactsErrors";

const reportBugUrl =
  "https://sunrun.service-now.com/help?id=sc_cat_item&sys_id=d0eab1f94fd84600170809d14210c7f3&sysparm_category=a3499ce4db570c10fb951e1339961972&spa=1";

type ProspectUnavailableModalProps = {
  onClose?: () => void;
};

const ProspectUnavailableModal = ({
  onClose,
}: ProspectUnavailableModalProps) => {
  const presentation = getProspectUnavailablePresentation();

  return (
    <Modal
      testId="prospect-unavailable-modal"
      type="error"
      title={presentation.title}
      onClose={onClose}
      hideClose
      {...(onClose
        ? {
            secondaryButton: { text: "Dismiss", onClick: onClose },
            primaryButton: {
              text: "Report bug",
              onClick: () => window.open(reportBugUrl, "_blank"),
            },
          }
        : {})}
    >
      <Content>
        <Typography color={tokens.TINTS_OFF_WHITE_20} style={{ fontSize: 20 }}>
          {presentation.description}
        </Typography>
      </Content>
    </Modal>
  );
};

const Content = styled.div`
  display: grid;
  gap: 1rem;
`;

export { ProspectUnavailableModal };
